import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export function servicesSlider() {
    const $services = document.querySelector(".section-services__items");

    if (!$services) return;

    const nextEl = $services.parentElement.querySelector(".slider-controls__arrow--next");
    const prevEl = $services.parentElement.querySelector(".slider-controls__arrow--prev");

    const swiperSlider = new Swiper($services, {
        slidesPerView: 4,
        spaceBetween: 24,
        modules: [Navigation],
        navigation: {
            nextEl,
            prevEl
        },
        breakpoints: {
            0: {
                slidesPerView: 1.105,
                spaceBetween: 16,
            },
            481: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 3.1,
                spaceBetween: 16,
            },
            1025: {
                slidesPerView: 4
            }
        }
    });
}